import React from 'react';
import { Bert } from 'meteor/themeteorchef:bert';
import PropTypes from 'prop-types';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { filter, isEmpty } from 'lodash';
import { Row } from 'react-bootstrap';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import TelemetryConnEditableTable from '../../components/TelemetryConnEditableTable';
import Loading from '../../components/Loading';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import TelemetrySelector from './TelemetrySelector';

const arrayServerTypes = [
  'CAT',
  'CATS',
  'DFS',
  'DTS',
  'GMS',
  'GMSS',
  'IGP',
  'IGPS',
  'OGC-API-Features'
];
const addTelConn = async newTelCon => {
  try {
    await methodPromise('telemetryConnections.insert', newTelCon);
    Bert.alert('Connection Created', 'success');
  } catch (error) {
    handleErrorInClient(error);
  }
};

const checkServerType = element => {
  if (element.serverType === 'GMS') {
    if (isEmpty(element.ip)) {
      return 'GMSS';
    }
    return element.serverType;
  }
  return element.serverType;
};

const updateTelConn = async newTelCon => {
  try {
    await methodPromise('telemetryConnections.update', newTelCon);
    Bert.alert('Connection Updated', 'success');
  } catch (error) {
    handleErrorInClient(error);
  }
};

const toggleSelected = async (telConId, isSelected) => {
  try {
    await methodPromise('telemetryConnections.toggleSelected', telConId, isSelected);
    Bert.alert('New Connection Selected', 'success');
  } catch (error) {
    handleErrorInClient(error);
  }
};

const removeTelConn = async telConId => {
  try {
    await methodPromise('telemetryConnections.hardDelete', telConId);
    Bert.alert('Connection Deleted', 'danger');
  } catch (error) {
    handleErrorInClient(error);
  }
};

const TelemetryConfigurationContainer = ({ loading, telemetryConnections, ...rest }) => {
  const [viewTable, setViewTable] = React.useState(false);
  const [serverByType, setServerBytype] = React.useState([]);

  const hanldeSelectorServerType = value => {
    if (value === 'All') {
      setServerBytype(telemetryConnections);
    } else {
      const filterConnection = filter(telemetryConnections, element => {
        const serverType = checkServerType(element);
        return serverType === value;
      });
      setServerBytype(filterConnection);
    }
    setViewTable(true);
  };

  const handleBackButton = () => {
    setViewTable(false);
  };

  const editableTableProps = {
    itemList: serverByType,
    addTelConn,
    updateTelConn,
    toggleSelected,
    removeTelConn
  };
  if (loading) {
    return <Loading />;
  }

  return (
    <>
      {viewTable === false ? (
        <>
          <div>
            <h4>All Connections</h4>
            <Row style={{ width: `${window.innerWidth}px` }}>
              <TelemetrySelector element="All" selectServer={hanldeSelectorServerType} />
            </Row>
          </div>
          <div style={{ paddingTop: '2%' }}>
            <h4>Types Connection</h4>
            <Row style={{ width: `${window.innerWidth}px` }}>
              {arrayServerTypes.map(value => (
                <TelemetrySelector
                  key={value}
                  element={value}
                  selectServer={hanldeSelectorServerType}
                />
              ))}
            </Row>
          </div>
        </>
      ) : (
        <TelemetryConnEditableTable
          {...editableTableProps}
          {...rest}
          backButton={handleBackButton}
        />
      )}
    </>
  );
};

TelemetryConfigurationContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  telemetryConnections: PropTypes.array.isRequired
};

export default withTracker(() => {
  const subscription = Meteor.subscribe('telemetryConnections');
  return {
    loading: !subscription.ready(),
    telemetryConnections: TelemetryConnections.find({}, { sort: { serverType: 1 } }).fetch()
  };
})(TelemetryConfigurationContainer);
